import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { api } from '../App';
import { MessageSquare, Save, Send, CheckCircle2, XCircle, RefreshCw } from 'lucide-react';

export default function SmsAyarlari() {
  const [form, setForm] = useState({
    api_url: '', api_key: '', api_kullanici: '', gonderen: '',
    dusuk_puan_esigi: 3, aktif: false, bildirim_telefonlari_str: ''
  });
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testTel, setTestTel] = useState('');
  const [testing, setTesting] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [a, l] = await Promise.all([api.get('/sms/ayarlar'), api.get('/sms/log')]);
      const d = a.data;
      setForm({
        api_url: d.api_url || '',
        api_key: d.api_key || '',
        api_kullanici: d.api_kullanici || '',
        gonderen: d.gonderen || '',
        dusuk_puan_esigi: d.dusuk_puan_esigi || 3,
        aktif: d.aktif || false,
        bildirim_telefonlari_str: (d.bildirim_telefonlari || []).join('\n'),
      });
      setLog(l.data);
    } catch { toast.error('Yüklenemedi'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleSave = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/sms/ayarlar', {
        ...form,
        bildirim_telefonlari: form.bildirim_telefonlari_str.split('\n').map(t => t.trim()).filter(Boolean),
      });
      toast.success('SMS ayarları kaydedildi');
    } catch (err) { toast.error(err.response?.data?.error || 'Hata'); }
    finally { setSaving(false); }
  };

  const handleTest = async () => {
    if (!testTel) return toast.error('Test için telefon numarası girin');
    setTesting(true);
    try {
      await api.post('/sms/test', { telefon: testTel });
      toast.success('Test SMS gönderildi');
    } catch (err) { toast.error(err.response?.data?.error || 'Gönderilemedi'); }
    finally { setTesting(false); }
  };

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
      <div className="spinner spinner-blue" style={{ width: 32, height: 32 }} />
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">SMS Ayarları</h1>
          <p className="page-subtitle">Düşük puan uyarı SMS entegrasyonu</p>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20, alignItems: 'start' }}>
        {/* Ayarlar formu */}
        <div className="card" style={{ padding: 24 }}>
          <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 14, borderBottom: '1px solid var(--gray-100)', marginBottom: 4 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <MessageSquare size={16} color="var(--blue)" />
                <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>SMS Entegrasyon Ayarları</h2>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <span style={{ fontSize: 13, fontWeight: 500, color: form.aktif ? 'var(--blue)' : 'var(--gray-400)' }}>
                  {form.aktif ? 'Aktif' : 'Pasif'}
                </span>
                <input
                  type="checkbox"
                  checked={form.aktif}
                  onChange={e => setForm({ ...form, aktif: e.target.checked })}
                  style={{ width: 18, height: 18 }}
                />
              </label>
            </div>

            <div className="input-group">
              <label className="input-label">API URL</label>
              <input className="input" type="url" value={form.api_url} onChange={e => setForm({ ...form, api_url: e.target.value })} placeholder="https://sms-provider.com/api/send" />
            </div>

            <div className="form-grid">
              <div className="input-group">
                <label className="input-label">API Key</label>
                <input className="input" type="password" value={form.api_key} onChange={e => setForm({ ...form, api_key: e.target.value })} placeholder="Mevcut key: ****" />
                <span style={{ fontSize: 11, color: 'var(--gray-400)', marginTop: 4 }}>Boş bırakılırsa mevcut key korunur</span>
              </div>
              <div className="input-group">
                <label className="input-label">API Kullanıcı</label>
                <input className="input" value={form.api_kullanici} onChange={e => setForm({ ...form, api_kullanici: e.target.value })} placeholder="kullanici@firma.com" />
              </div>
              <div className="input-group">
                <label className="input-label">Gönderen (Sender)</label>
                <input className="input" value={form.gonderen} onChange={e => setForm({ ...form, gonderen: e.target.value })} placeholder="KEYFICLEAN" maxLength={11} />
              </div>
              <div className="input-group">
                <label className="input-label">Düşük Puan Eşiği (altına düşünce uyarı)</label>
                <select className="input" value={form.dusuk_puan_esigi} onChange={e => setForm({ ...form, dusuk_puan_esigi: parseInt(e.target.value) })}>
                  {[1,2,3,4].map(v => <option key={v} value={v}>{v} yıldız ve altı</option>)}
                </select>
              </div>
            </div>

            <div className="input-group">
              <label className="input-label">Bildirim Telefon Numaraları (her satıra bir numara)</label>
              <textarea
                className="input"
                rows={4}
                value={form.bildirim_telefonlari_str}
                onChange={e => setForm({ ...form, bildirim_telefonlari_str: e.target.value })}
                placeholder="+905XXXXXXXXX&#10;+905XXXXXXXXX"
                style={{ resize: 'vertical', fontFamily: 'monospace' }}
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? <div className="spinner" /> : <Save size={15} />}
                Ayarları Kaydet
              </button>
            </div>
          </form>
        </div>

        {/* Yan panel */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* Test SMS */}
          <div className="card" style={{ padding: 20 }}>
            <h3 style={{ margin: '0 0 14px', fontSize: 14, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 6 }}>
              <Send size={14} color="var(--blue)" /> Test SMS Gönder
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <input className="input" type="tel" placeholder="+905XXXXXXXXX" value={testTel} onChange={e => setTestTel(e.target.value)} />
              <button className="btn btn-secondary" onClick={handleTest} disabled={testing}>
                {testing ? <div className="spinner spinner-blue" style={{ width: 16, height: 16 }} /> : <Send size={14} />}
                Gönder
              </button>
            </div>
          </div>

          {/* SMS Durum */}
          <div className="card" style={{ padding: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700 }}>Son SMS Logları</h3>
              <button className="btn btn-ghost btn-icon btn-sm" onClick={load} title="Yenile"><RefreshCw size={14} /></button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 320, overflowY: 'auto' }}>
              {log.map(l => (
                <div key={l.id} style={{ padding: '10px 12px', borderRadius: 10, background: l.basarili ? '#f0fdf4' : '#fef2f2', border: `1px solid ${l.basarili ? '#bbf7d0' : '#fecaca'}` }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    {l.basarili
                      ? <CheckCircle2 size={13} color="#16a34a" />
                      : <XCircle size={13} color="#dc2626" />
                    }
                    <span style={{ fontSize: 13, fontWeight: 600 }}>{l.telefon}</span>
                    <span style={{ fontSize: 11, color: 'var(--gray-400)', marginLeft: 'auto' }}>
                      {new Date(l.olusturma_tarihi).toLocaleString('tr-TR')}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--gray-600)' }}>{l.mesaj?.slice(0, 60)}...</div>
                  {l.hata_mesaji && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 3 }}>{l.hata_mesaji}</div>}
                </div>
              ))}
              {!log.length && <p style={{ color: 'var(--gray-400)', fontSize: 13, textAlign: 'center', padding: 16 }}>Henüz SMS logu yok</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
